import { PayloadAction } from "@reduxjs/toolkit";

import { AppState } from "editor/src/store/app/types";

const setMultiTechModeReducer = (
  state: AppState,
  { payload }: PayloadAction<boolean>,
) => {
  state.multiTechMode = payload;
};

export default setMultiTechModeReducer;
